import axios from 'axios';

import { getAuthorizationHeader } from './auth_service';

export const getAccount = async (accountId) => {
  let res = await axios.get(process.env.REACT_APP_BACKEND_URL + 'api/accounts/' + accountId +'?populate=*', getAuthorizationHeader())

  return res.data.data;
}

export const putAccount = async (accountId, body) => {
  let data = {
    data: {
      ...body
    }
  }

  let res = await axios.put(process.env.REACT_APP_BACKEND_URL + `api/accounts/${accountId}`, data,
  getAuthorizationHeader())

  return res.data.data;
}


export const getAccountTeams = async (accountId) => {
  let res = await getAccount(accountId);

  return res.attributes.team.data
}